import { useRouter } from 'next/router';
import { BookSlugs, BookPathSlugs, BookSheetSlugs } from '@utils/types/bookSlugs';

export const useBookSlugs = (): BookSlugs => {
    const router = useRouter();
    const { bookId } = router.query as unknown as BookSlugs;

    return { bookId };
};

export const useBookPathSlugs = (): BookPathSlugs => {
    const router = useRouter();

    return router.query as unknown as BookPathSlugs;
};

export const useBookSheetSlugs = (): BookSheetSlugs => {
    const router = useRouter();

    return router.query as unknown as BookSheetSlugs;
};
